import React, { useCallback, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import '../fichierCss/Accueil.css';
import Adresse from '../composants/Adresse';
import video from '../images/navigation/video.mp4';
import EvenementsContainer from './EvenementsContainer';
import Don from '../composants/Don';
import ImageGenerique from '../composants/ImageGenerique';
import DescriptionGenerique from '../composants/DescriptionGenerique';
import Ressource from '../modeles/Ressource';
import { obtenirUrlImage } from '../utils/ressourceImageUtils';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    boxSizing: 'border-box',
    paddingLeft: '0.45rem',
    paddingRight: '0.45rem',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    margin: '0 auto',
    [theme.breakpoints.up('md')]: {
      paddingLeft: '0.45rem',
      paddingRight: '0.45rem',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
    maxWidth: '100%',
  },
  card: {
    borderRadius: 0,
    overflow: 'hidden',
    boxShadow: 'none',
    padding: theme.spacing(2),
    height: '100%',
    background: 'transparent',
  },
  video: {
    width: '100%',
    height: '440px',
    maxHeight: '70vh',
    objectFit: 'cover',
    borderRadius: '8px',
    display: 'block',
    background: '#000',
  },
  mediaShell: {
    width: '100%',
    minHeight: 260,
    maxHeight: 420,
    overflow: 'hidden',
    marginBottom: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    background: '#f1f7fb',
    border: '1px solid rgba(15, 45, 63, 0.1)',
  },
  mediaTitle: {
    marginTop: theme.spacing(1.25),
    marginBottom: theme.spacing(0.5),
    fontWeight: 700,
    fontSize: '1.35rem',
    color: '#12354a',
    textAlign: 'center',
    width: '100%',
  },
  descriptionWrap: {
    marginTop: theme.spacing(1.2),
    padding: theme.spacing(1.5, 1.25),
    borderRadius: 8,
    background: '#ffffff',
    border: '1px solid rgba(15, 45, 63, 0.1)',
    maxHeight: 230,
    overflowY: 'auto' as 'auto',
  },
  sectionTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(1.5),
    color: '#333',
  },
  rowBottom: {
    marginTop: theme.spacing(1),
  },
}));

export default function AccueilContainer() { 
  const classes = useStyles();
  const [imageChoisie, setImageChoisie] = useState<string>('');
  const [titreAffiche, setTitreAffiche] = useState('');
  const [description, setDescription] = useState('');
  const [evenementSelectionne, setEvenementSelectionne] = useState(false);

  const handleEvenementClick = useCallback((evenement: Ressource) => {
    console.log('Evenement cliqué :', evenement);
    const imageUrl = obtenirUrlImage(evenement);
    console.log('Evenement imageUrl :', imageUrl);
    setImageChoisie(imageUrl);
    setTitreAffiche(evenement.titre || '');
    setDescription(evenement.description || evenement.resume || '');
    setEvenementSelectionne(true);
  }, []);

  return (
    <div className={classes.root}>
      <Grid container spacing={3} alignItems="stretch">
        {/* Ligne 1 : Vidéo + Événements */}
        <Grid item xs={12} md={8}>
          <Paper className={classes.card} style={{ height: '100%' }}>
            {!evenementSelectionne ? (
              <video className={classes.video} controls>
                <source src={video} type="video/mp4"/>
                <source src="movie.ogg" type="video/ogg"/>
              </video>
            ) : (
              <>
                <div className={classes.mediaShell}>
                  <ImageGenerique key={imageChoisie} image={imageChoisie} titre={titreAffiche} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div className={classes.mediaTitle}>{titreAffiche}</div>
                <Divider style={{ margin: '8px 0' }} />
                <div className={classes.descriptionWrap}>
                  <DescriptionGenerique description={description} />
                </div>
              </>
            )}
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper className={classes.card} style={{ height: '480px', maxHeight: '70vh', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
              <EvenementsContainer variant="list" onEvenementClick={handleEvenementClick} />
            </div>
          </Paper>
        </Grid>
      </Grid>

      {/* Ligne 2 : Don et Adresse alignés */}
      <Grid container spacing={3} style={{ marginTop: 24 }}>
        <Grid item xs={12} md={6}>
          <Paper className={classes.card}>
            <h2 className={classes.sectionTitle}>Faire un don</h2>
            <Divider style={{ marginBottom: '12px' }} />
            <Don />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper className={classes.card} id="map">
            <h2 className={classes.sectionTitle}>Adresse</h2>
            <Divider style={{ marginBottom: '12px' }} />
            <Adresse/>
          </Paper>
        </Grid>
      </Grid>

    </div>
  );
}

